<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'app',
  created () {
    this.$store.dispatch('tryAutoLogin')
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        // if you ever get an unauthorized, logout the user
          this.$store.dispatch('logout')
        // you can also redirect to /login if needed !
        }
        throw err
      })
    })
  }
}
</script>

<style>
@import url('../node_modules/@alegradev/smile-ui-alegra/dist/smile-ui-alegra.css');
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
@import url('./normalize.css');

html, body {
  font-family: 'Roboto', sans-serif;
}

#app {
  color: #2c3e50;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
